import { repoCaseService } from "../services/repoCase.service";
import { parseUploadBatchId } from "./uploadBatchId";

const POLL_MS = 2000;
const POLL_TIMEOUT_MS = 4 * 60 * 60 * 1000;

function asInt(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

/**
 * Do not treat a batch as done just because status=completed.
 * Split must have written a manifest and all chunks must be finished.
 */
export function isUploadBatchComplete(batch) {
  if (!batch) return false;
  const status = String(batch.status || "");
  if (status === "failed") return false;
  if (status !== "completed") return false;
  const chunks = asInt(batch.totalChunks);
  if (chunks <= 0) return true;
  const failed = asInt(batch.failedChunks);
  const done = asInt(batch.completedChunks);
  const processed = asInt(batch.processedRows);
  const total = asInt(batch.totalRows);
  const splitFinished = Boolean(String(batch.manifestS3Key || "").trim());
  return (
    splitFinished &&
    done === chunks &&
    failed === 0 &&
    total > 0 &&
    processed === total
  );
}

export function isUploadBatchFailed(batch) {
  const status = String(batch?.status || "");
  return status === "failed" || status === "partial";
}

/**
 * Poll upload batch until fully completed or failed. Calls onProgress(batch) each tick.
 */
export async function pollUploadUntilDone(batchId, token, { onProgress } = {}) {
  const id = parseUploadBatchId(batchId);
  const started = Date.now();

  const tick = async () => {
    if (Date.now() - started > POLL_TIMEOUT_MS) {
      throw new Error("Upload timed out waiting for the worker to finish.");
    }
    const res = await repoCaseService.getUploadById(id, token);
    const batch = res?.data;

    if (typeof onProgress === "function") {
      onProgress(batch);
    }

    if (isUploadBatchComplete(batch)) {
      return batch;
    }

    if (isUploadBatchFailed(batch)) {
      throw new Error(
        batch?.errorMessage ||
          batch?.message ||
          "Upload failed. Please check the Excel file and try again."
      );
    }

    await new Promise((r) => setTimeout(r, POLL_MS));
    return tick();
  };

  return tick();
}

export { POLL_MS, POLL_TIMEOUT_MS };
